module.exports = __webpack_public_path__ + "static/media/boshilun2.f8f602e4.png";